import { crudMutations, crudActions } from './modules/action-helpers'

const basePath = 'api/shipper'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath }),
    async available ({ dispatch, state }, params) {
      return dispatch('list', { basePath: `${basePath}/available`, params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async getNames ({ dispatch, state }, params) {
      return dispatch('list', { basePath: `${basePath}/autocomplete_name`, params: params }, { root: true })
        .then(response => { return response.results })
        .catch(error => { throw error })
    },
    async getPlates ({ dispatch, state }, params) {
      return dispatch('list', { basePath: `${basePath}/autocomplete_plate`, params: params }, { root: true })
        .then(response => { return response.results })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/trucks.js